<template>
  <div>
    <k-progress
      :percent="percent"
      :showText="showText"
      :color="getColor"
      :active="active"
      :bgColor="bgColor"
      :status="status"
      :lineHeight="lineHeight"
      :colorFlow="colorFlow"
      :activeColor="activeColor"
      :type="type"
    ></k-progress>
  </div>
</template>

<script>
export default {
  name: 'resourcesGauge',
  props: {
    percent: {
      type: Number,
      default: 0,
      required: true,
      validator: (val) => val >= 0 && val <= 100,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    bgColor: {
      type: String,
      default: '#ebeef5',
    },
    type: {
      type: String,
      default: 'line',
      validator: (val) => ['line', 'lump'].indexOf(val) > -1,
    },
    border: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      validator: (val) => ['success', 'warning', 'error'].indexOf(val) > -1,
    },
    lineHeight: {
      type: Number,
      default: 6,
    },
    color: {
      type: [String, Array, Function],
      default: '',
    },
    colorFlow: {
      type: Boolean,
      default: false,
    },
    activeColor: {
      type: [String, Array],
      default: '',
    },
    format: {
      type: Function,
    },
    total: {
      type: String
    }
  },
  data() {
    return {}
  },
  methods: {
    getColor(percent) {
      if (percent < 65) {
        return '#1E9600'
      } else if (percent < 80) {
        return '#fadb14'
      } else if (percent < 90) {
        return '#FFF200'
      } else {
        return '#FF0000'
      }
    },
    getText() {
      return this.total.replace(' ','')
      
    }
  },
}
</script>
